import angular from 'angular';


class Brands {
  constructor(appAPI, brandsListsManager, entitiesFormatter) {
    'ngInject';

    this.appAPI = appAPI;
    this.brandsListsManager = brandsListsManager;
    this.entitiesFormatter = entitiesFormatter;
  }
  newList() {
    return this.brandsListsManager.newList();
  }
  byId(brandId) {
    return this.appAPI.brand(brandId)
    .then((response) => this.entitiesFormatter.brand(response));
  }
  permissions(brandIds) {
    const list = angular.isArray(brandIds) ? brandIds : [brandIds];
    return this.appAPI.brandPermissions(list);
  }
  adminSettings(brandId) {
    return this.appAPI.brandAdminSettings(brandId)
    .then((response) => ({
      permissions: response.permissions,
      user_accounts: response.user_accounts.map((user) => this.entitiesFormatter.user(user)),
    }));
  }
  saveAdminSettings(brandId, userIds, permissionIds) {
    return this.appAPI.saveBrandAdminSettings(brandId, userIds, permissionIds);
  }
}

export default Brands;
